import { Box } from "@mui/material";
import AboutSection from "./sections/AboutSection";
import ContractManagementSection from "./sections/ContractManagementSection";
import HeroSection from "./sections/HeroSection";
import InnovativeSolutions from "./sections/InnovativeSolutions";
import PartnersSection from "./sections/PartnersSection";
// import StatsBar from "./sections/StatsBar";
import TechnologyServices from "./sections/TechnologyServices";

const Home = () => (
  <Box sx={{ overflow: "hidden" }}>
    <HeroSection />
    <InnovativeSolutions />
    <TechnologyServices />
    <ContractManagementSection />
    <AboutSection />
    {/* <StatsBar /> */}
    <PartnersSection />
  </Box>
);

export default Home;
